import { render, staticRenderFns } from "./selectValue.vue?vue&type=template&id=0c134b94&"
import script from "./selectValue.vue?vue&type=script&lang=js&"
export * from "./selectValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "selectValue.vue"
export default component.exports